import * as React from 'react';
import { QuestionRadiogroupModel, ItemValue } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { List, ListItem, ListItemText, ListItemIcon, Icon, styled } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const TYPE = 'mui-list';

export class MuiListModel extends QuestionRadiogroupModel {
  getType(): string {
    return TYPE;
  }

  get listAlert() {
    return this.getPropertyValue('listAlert');
  }
  set listAlert(val) {
    this.setPropertyValue('listAlert', val);
  }
}

const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderRadius: '12px',
  marginTop: '10px',
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(1),
    paddingTop: 15,
    paddingBottom: 15,
    border: '1px solid var(--gray-border)',
    '&:first-child': {
      marginTop: theme.spacing(2)
    }
  },
  '&:hover, &.Mui-selected, &.Mui-selected:hover': {
    background: 'var(--primary-04-)',
    boxShadow: '0 3px 1px -2px rgba(0,0,0,0.2), 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12)'
  },
  '&.Mui-selected': {
    border: '1px solid var(--primary)',
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    '& .MuiListItemText-primary': {
      fontWeight: '600',
      color: 'var(--gray-text)'
    }
  },
  '& .MuiListItemText-secondary': {
    color: 'var(--list-secondary)',
    [theme.breakpoints.down('md')]: {
      letterSpacing: 0.25
    }
  },
  '& .MuiListItemText-primary': {
    color: 'var(--gray-text)'
  },
  '& .MuiListItemText-multiline': {
    [theme.breakpoints.down('md')]: {
      marginTop: 3,
      marginBottom: 3
    }
  }
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  alignSelf: 'flex-start',
  marginRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    marginRight: theme.spacing(0)
  }
}));

const StyledIcon = styled(Icon)(({ theme }) => ({
  textAlign: 'center',
  width: 56,
  height: 56,
  '& img': {
    width: '100%',
    height: '100%'
  },
  [theme.breakpoints.down('md')]: {
    width: 40,
    height: 40
  }
}));

export class MuiList extends SurveyQuestionElementBase {
  inputRef = React.createRef<HTMLDivElement>();

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    if (!this.question.value && this.question.choices[0].value) {
      this.question.value = this.question.choices[0].value;
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.question.questionRef = this.inputRef;
  }

  get question() {
    return this.questionBase;
  }

  get choices() {
    return this.question.choices;
  }

  get listAlert() {
    return this.question.listAlert;
  }

  handleChange(value: string) {
    this.question.value = value;
  }

  protected renderElement(): JSX.Element | null {
    return (
      <>
        {this.listAlert && (
          <Alert severity={this.listAlert.variant}>
            <b>{this.listAlert.label}</b>
          </Alert>
        )}
        <List>
          {this.choices
            .filter(({ visible }: ItemValue) => visible)
            .map(({ value, text, tooltip, iconSrc }: ItemValue, index: number) => (
              <StyledListItem
                button
                tabIndex={1}
                ref={index === 0 ? this.inputRef : null}
                onClick={() => this.handleChange(value)}
                key={value}
                selected={this.question.value === value}
              >
                <StyledListItemIcon>
                  <StyledIcon>
                    <img src={`${process.env.PUBLIC_URL}${iconSrc}`} alt={text} />
                  </StyledIcon>
                </StyledListItemIcon>
                <ListItemText primary={text} {...(this.question.value === value ? { secondary: tooltip } : {})} />
              </StyledListItem>
            ))}
        </List>
      </>
    );
  }
}
